import React from "react";
import BaseComponent from "../../../base/BaseComponent";
import PageTemplate from "../../newMediaMatrix/components/pageTemplate/PageTemplate";
import TabsTemplate from "../../newMediaMatrix/components/TabsTemplate/TabsTemplate";
import PropTypes from 'prop-types';

export default class GradeTabs extends BaseComponent {
    static defaultProps = {
        onChange: () => {
        },
        style: {}
    };
    static propTypes = {
        onChange: PropTypes.func,
    };

    constructor(props) {
        super(props);
        this.state = {
            tabKey: "",
            tabsData: []
        }
    }

    componentDidMount() {
        this.getTabsData()
    }

    getTabsData() {
        this.request({
            url: '/cm-sites-media-consumer/position/overview/getPositionTypeGrade',
            body: {},
            callBack: (data) => {
                let tabsData = [];
                if (data && data.length) {
                    data = [{gradeKey: "", grade: "全部"}, ...data];
                    tabsData = data.map(item => {
                        return {key: item.gradeKey, name: item.grade}
                    })
                }
                this.setState({
                    tabsData
                });
            },
            errorCallBack: (e) => {
            },
        })
    }

    render() {
        const {onChange, onResize, style} = this.props;
        const {tabKey, tabsData} = this.state;
        return (
            <>
                <PageTemplate styleOut={{margin: "0 0 15px 0"}} style={{...style}}>
                    <TabsTemplate
                        key={"GradeTabs" + tabKey}
                        tabChange={(val) => {
                            onChange(val);
                            this.setState({
                                tabKey: val
                            })
                        }}
                        nav={tabsData}
                        tabKey={tabKey}
                        onResize={(offsetHeight) => {
                            onResize(offsetHeight)
                        }}
                        styleOut={{paddingLeft: "32px"}}
                    />
                    {this.props.children}
                </PageTemplate>
            </>
        );
    }
}